<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-10 15:16:20
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 11:42:04
-->
<template>
  <div class="innovative intracranial">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require(`@/assets/images/pc/innovate${language == 'en' ? '/en' : ''}/skull_bj.png`)" alt="" srcset="">
      <div v-if="language != 'en'" class="innovative-bj-txt" @click="$router.push({ path: language == 'en' ? '/en/guidance' :'/guidance' })"></div>
    </div>
    <div class="innovative-process innovative-wrap-item">
      <div class="innovative-container">
        <img @contextmenu="($event) => {$event.returnValue = false; return false}" @dragstart.prevent class="innovative-process-img" :src="$t('product.skull.processImg')" alt="" srcset="">
      </div>
    </div>
    <div class="innovative-intelligence innovative-wrap-item p-0 posrel">
      <img class="wid100" :src="$t('product.skull.intelligence.img')" alt="" srcset="">
      <div class="flex innovative-container posabs hei100 align_items_center textj" :class="language != 'en' ? 't--40' : 't--20'">
        <div :class="['flex flex_col justify_content_center', language == 'en' ? 'flex_2 posrel t-60' : 'flex_1']" :style="{'padding-right': language == 'en' ? '2%' : '5%'}">
          <div class="innovative-wrap-item-title p-b-40" :class="language == 'en' ? 'nowrap' : ''">
            <p v-for="item, index in $t('product.skull.intelligence.title')" :key="index" v-html="item"></p>
          </div>
          <div>
            <p :class="{'p-b-20': language == 'en'}" v-for="item, index in $t('product.skull.intelligence.des')" :key="index" v-html="item"></p>
          </div>
        </div>
        <div :class="['flex align_items_center justify_content_end', language == 'en' ? 'flex_3' : 'flex_2']">
        </div>
      </div>
    </div>
    <div class="innovative-advantages innovative-wrap-item">
      <div class="innovative-container">
        <div class="flex">
          <div class="flex_1 flex align_items_center p-r-90">
            <img class="wid100" :src="$t('product.skull.coreAdvantages.img')" alt="" srcset="">
          </div>
          <div class="flex_1" :class="{ textj: language != 'en'}">
            <div class="innovative-wrap-item-title innovative-advantages-title fz-30">{{$t('product.skull.coreAdvantages.title')}}</div>
            <div class="">
              <p class="innovative-advantages-des" :class="{ en: language == 'en' }" v-for="item, index in $t('product.skull.coreAdvantages.des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
        <div class="flex flex_wrap innovative-advantages-box">
          <div class="innovative-advantages-item flex" :class="{ en: language == 'en', align_items_center: language != 'en'}" v-for="item, index in $t('product.skull.coreAdvantages.list')" :key="index">
            <div class="innovative-advantages-item-img">
              <img class="" :src="item.img" alt="" srcset="">
            </div>
            <div class="flex_1" :class="{ flex: language != 'en'}">
              <div class="innovative-advantages-item-title" :class="language == 'en' ? 'fz-22' : 'fz-30'" :style="{'min-width': index % 2 == 0 ? '4em' : '5em'}">{{item.title}}</div>
              <p :class="language == 'en' ? 'fz-18 p-t-8' : 'fz-20'" :style="language == 'en' ? 'padding-left: 1em;' : ''">{{item.des}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-products innovative-wrap-item p-t-45">
      <div class="innovative-container">
        <div class="innovative-products-title innovative-wrap-item-title textc p-b-45 fz-30">{{$t('product.skull.relatedProducts.title')}}</div>
        <el-row :gutter="15" class="flex justify_content_center">
          <el-col :span="6" class="" v-for="item, index in $t('product.skull.relatedProducts.list')" :key="index">
            <div :class="['innovative-products-item', item.disabled ? 'disabled' : 'cursor_pointer']" @click="item.disabled ? '' : $router.push({ path: item.path })" >
              <div class="innovative-products-mask flex justify_content_center align_items_center" v-if="item.disabled"><span class="txt">敬请期待</span></div>
              <img class="wid100" :src="item.img" alt="" srcset="">
              <el-tooltip popper-class="tooltip-item" effect="dark" placement="bottom-end" :offset="6" :disabled="index == 0 ? tooltipOne1 : index == 1 ? tooltipOne2 : index == 2 ? tooltipOne3 : tooltipOne4">
                <div slot="content" v-html="item.title"></div>
                <div class="innovative-products-item-title ellipsis" v-html="item.title" @mouseenter="projectMouseenter($event, `tooltipOne${index + 1 }`)" @mouseleave="projectMouseleave()"></div>
              </el-tooltip>
              <i class="t">&nbsp;</i>
              <i class="r">&nbsp;</i>
              <i class="b">&nbsp;</i>
              <i class="l">&nbsp;</i>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="innovative-stroke innovative-common-wrap innovative-wrap-item">
      <div class="posrel">
        <img class="wid100" :src="$t('product.skull.stroke.bjImg')" alt="" srcset="">
        <div class="innovative-container innovative-stroke-box innovative-common-box flex align_items_center">
          <div class="flex_1"></div>
          <div class="flex_1 textj">
            <div class="innovative-stroke-title innovative-wrap-item-title innovative-common-title nowrap" v-html="$t('product.skull.stroke.title')"></div>
            <div class="innovative-stroke-des innovative-common-des">
              <p v-for="item, index in $t('product.skull.stroke.des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-common-main innovative-stroke-summary-box p-b-20">
        <div class="innovative-container">
          <div class="flex">
            <div class="innovative-stroke-summary flex_3 p-r-65">
              <div class="ilblk">
                <div class="textc" :class="language
                 == 'en' ? 'p-b-170' : 'p-b-70'">
                  <div class="innovative-wrap-item-title" :class="{en: language == 'en', nowrap: language != 'en'}">{{$t('product.skull.stroke.summary.des')[1]}}</div>
                  <p class="innovative-stroke-summary-sign">{{$t('product.skull.stroke.summary.des')[2]}}</p>
                </div>
                <div class="posrel" :style="language
                 == 'en' ? 'width: 90%' : ''">
                  <img class="" :src="$t('product.skull.stroke.summary.img')" alt="" srcset="">
                  <div role="tooltip" aria-hidden="false" class="el-popover el-popper el-popover--plain lh-30" :class="language == 'en' ? 'p-16 p-l-26 p-r-26' : 'p-16 p-l-26 p-r-26'" :style="{right: language == 'en' ? '-10.5%' : '-5%', top: language == 'en' ? '-90px' : '-7px'}">
                    <div class="" v-html="$t('product.skull.stroke.summary.des')[0]"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex_2 flex flex_col align_items_end posrel">
              <div class="" :style="{ width: '66%' }">
              <!-- <div class="" :style="{ width: '302px' }"> -->
                <div class="posrel">
                  <div class="m-b-20 innovative-products-item cursor_pointer" v-for="item, index in $t('product.skull.stroke.products.list')" :key="index"  @click="$router.push({ path: item.path })">
                    <img class="wid100" :src="item.img" alt="" srcset="">
                    <el-tooltip popper-class="tooltip-item" effect="dark" placement="bottom-end" :offset="6" :disabled="index == 0 ? tooltipTwo1 : tooltipTwo2">
                      <div slot="content" v-html="item.title"></div>
                      <div class="innovative-products-item-title ellipsis" v-html="item.title" @mouseenter="projectMouseenter($event, `tooltipTwo${index + 1 }`)" @mouseleave="projectMouseleave()"></div>
                    </el-tooltip>
                    <i class="t">&nbsp;</i>
                    <i class="r">&nbsp;</i>
                    <i class="b">&nbsp;</i>
                    <i class="l">&nbsp;</i>
                  </div>
                </div>
              </div>
              <div class="wid100">
                <div role="tooltip" aria-hidden="false" class="el-popover el-popper el-popover--plain lh-30" :class="[language == 'en' ? 'r-0 p-l-30 p-t-20 p-b-20' : 'textj b-0', language == 'en' ? 'b--40' : (clientWidth >= 1920 ? 'l--40' : '')]" x-placement="right-end" :style="{ width: language == 'en' ? '135%' : '100%'}">
                  <div class="el-popover-des" :class="{en: language == 'en'}" v-for="item, index in $t('product.skull.stroke.list')" :key="index" v-html="item"></div>
                  <div x-arrow="" class="popper__arrow" style="top: 30px;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-narrow innovative-common-wrap innovative-wrap-item">
      <div class="posrel">
        <img class="wid100" :src="$t('product.skull.narrow.bjImg')" alt="" srcset="">
        <div class="innovative-container innovative-narrow-box innovative-common-box flex align_items_center">
          <div :class="language == 'en' ? 'flex_1' : 'flex_2'">
            <div class="innovative-narrow-title innovative-common-title innovative-wrap-item-title" :class="{nowrap: language != 'en'}">
              <p v-for="(item, index) in $t('product.skull.narrow.title')" :key="index" v-html="item"></p>
            </div>
            <div class="innovative-narrow-des" :class="language == 'en' ? 'p-b-1 p-r-80 textj' : ''" v-html="$t('product.skull.narrow.des')"></div>
          </div>
          <div :class="language == 'en' ? 'flex_1' : 'flex_3'"></div>
        </div>
      </div>
      <div class="p-t-100 p-b-60">
        <div class="innovative-container">
          <div class="flex">
            <div class="flex_3 p-l-40 p-r-65 p-t-25">
              <div class="ilblk">
                <img class="" :src="$t('product.skull.narrow.summary.img')" alt="" srcset="">
                <div v-if="language != 'en'" class="p-t-30 flex justify_content_center align_items_center color_0561E7">
                  <p class="" v-for="item, index in $t('product.skull.narrow.summary.des')" :key="index">
                    <span v-if="index != 0" class="p-l-10 p-r-10">•</span>
                    <span v-html="item"></span>
                  </p>
                </div>
                <div v-else class="p-t-30 color_0561E7 ilblk" :class="{'p-l-60': language == 'en'}">
                  <div class="flex justify_content_center align_items_center">
                    <p v-html="' • ' + $t('product.skull.narrow.summary.des')[0]" class="p-r-4"></p>
                    <p v-html="' • ' + $t('product.skull.narrow.summary.des')[1]"></p>
                  </div>
                  <p class="textc" v-html="' • ' + $t('product.skull.narrow.summary.des')[2]"></p>
                </div>
              </div>
            </div>
            <div class="flex_2 flex flex_col align_items_end posrel">
              <div class="" :style="{ width: '66%' }">
                <div class="posrel">
                  <div class="m-b-25 innovative-products-item cursor_pointer" v-for="item, index in $t('product.skull.narrow.products.list')" :key="index"  @click="$router.push({ path: item.path })">
                    <img class="wid100" :src="item.img" alt="" srcset="">
                    <el-tooltip popper-class="tooltip-item" effect="dark" placement="bottom-end" :offset="6" :disabled="index == 0 ? tooltipThree1 : tooltipThree2">
                      <div slot="content" v-html="item.title"></div>
                      <div class="innovative-products-item-title ellipsis" v-html="item.title" @mouseenter="projectMouseenter($event, `tooltipThree${index + 1 }`)" @mouseleave="projectMouseleave()"></div>
                    </el-tooltip>
                    <i class="t">&nbsp;</i>
                    <i class="r">&nbsp;</i>
                    <i class="b">&nbsp;</i>
                    <i class="l">&nbsp;</i>
                  </div>
                </div>
              </div>
              <div class="wid100">
                <div role="tooltip" aria-hidden="false" class="el-popover el-popper el-popover--plain lh-30 p-l-30 l--30" :class="clientWidth <= 1490 ? 'posrel': 'b-70'" :style="{width: language == 'en' ? '100%' : '80%;'}" x-placement="right-end">
                  <p class="flex align_items_center textj" v-for="item, index in $t('product.skull.narrow.list')" :key="index" v-html="item"></p>
                  <div x-arrow="" class="popper__arrow" style="top: 30px;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      box1: true,
      box2: true,
      tooltipOne1: true,
      tooltipOne2: true,
      tooltipOne3: true,
      tooltipOne4: true,
      tooltipTwo1: true,
      tooltipTwo2: true,
      tooltipThree1: true
    }
  },
  computed: {
    ...mapGetters(['language', 'clientWidth'])
  },
  methods: {
    projectMouseenter (ev, name) {
      this[name] = ev.target.clientWidth >= ev.target.scrollWidth
    },
    projectMouseleave () {
      this.tooltipOne1 = true
      this.tooltipOne2 = true
      this.tooltipOne3 = true
      this.tooltipOne4 = true
      this.tooltipTwo1 = true
      this.tooltipTwo2 = true
      this.tooltipThree1 = true
    }
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
.el-tooltip__popper.tooltip-item.is-dark {
  background: rgba(0, 0, 0, 0.6);
  transform: translate3d(-14PX, -14PX, 0);
  &[x-placement^=bottom-end] .popper__arrow{
    border-bottom-color: rgba(0, 0, 0, 0.6);
    right: 10PX;
    left: auto !important;
    &::after {
      border-bottom-color: rgba(0, 0, 0, 0);
    }
  }
}
</style>

<style lang="less" scoped>
.pc .innovative.intracranial {
  .innovative-advantages {
    .innovative-advantages-box {
      background: #FFFFFF;
      box-shadow: 0PX 4PX 12PX 4PX rgba(81, 170, 255, 0.1);
      border-radius: 8PX;
      margin-top: 80PX;
      padding: 20PX;
    }
    .innovative-advantages-item {
      padding-left: 60PX;
      .innovative-advantages-item-img {
        width: 50PX;
        margin-right: 0;
      }
      &.en {
        padding-left: 40PX;
        &:nth-of-type(2n) {
          padding-left: 40PX;
        }
      }
    }
  }
  .innovative-advantages-des {
    font-size: 18PX;
    line-height: 34PX;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      width: 6PX;
      height: 6PX;
      background: #0A9FE3;
      border-radius: 3PX;
      left: -16PX;
      top: 14PX;
    }
    &.en {
      font-size: 16PX;
      padding-bottom: 10PX;
    }
  }
  .innovative-stroke {
    padding-top: 0;
  }
  .innovative-stroke-summary-box {
    padding-top: 65PX;
    padding-bottom: 0;
  }
  .innovative-stroke-summary {
    .innovative-wrap-item-title {
      letter-spacing: 5.4PX;
      &.en {
        padding-bottom: 0PX;
        font-size: 26PX;
        letter-spacing: 0;
      }
    }
    .innovative-stroke-summary-sign {
      background: linear-gradient(90deg, #0556EA 0%, #02C2D0 100%);
      color: #ffffff;
      display: inline-block;
      padding: 0 22PX;
      margin-top: 10PX;
    }
  }
  .innovative-narrow .innovative-narrow-box {
    .innovative-narrow-des {
      padding-bottom: 5%;
    }
  }
  .el-popover {
    padding-left: 60PX;
  }
  .el-popover-des {
    position: relative;
    font-size: 18PX;
    padding-left: 20PX;
    &.en {
      font-size: 16PX;
      padding-bottom: 6PX;
    }
    &::before {
      content: '';
      position: absolute;
      width: 6PX;
      height: 6PX;
      background: #0A9FE3;
      border-radius: 3PX;
      left: 0PX;
      top: 12PX;
    }
  }
}
</style>

<style lang="less" scoped>
@media screen and (max-width: 1600PX) {
  .pc .innovative.intracranial {
    .innovative-products {
      padding-top: 0;
    }
  }
}
@media screen and (max-width: 1400PX) {
  .pc .innovative.intracranial {
  }
}
@media screen and (max-width: 1024PX) {
  .pc .innovative.intracranial {
    .innovative-advantages {
      padding-bottom: 80PX;
      .innovative-advantages-item{
        padding-left: 50PX;
      }
    }
    .innovative-products {
      padding-bottom: 60PX;
    }
    .innovative-stroke-box {
      .innovative-stroke-title {
        padding-left: 10%;
      }.innovative-stroke-des {
        padding-left: 10%;
        padding-bottom: 5%;
      }
    }
    .innovative-narrow .innovative-narrow-box {
      .innovative-narrow-title {
        padding-bottom: 16PX;
      }
      .innovative-narrow-des {
        padding-bottom: 2%;
      }
    }
  }
}
</style>
